export default {
    ConvertLinkRecordType: {
        "0": "创建新链路",
        "1": "绑定渠道",
        "2": "解绑渠道",
        "3": "添加链路行为",
        "4": "修改行为配置",
        "5": "删除链路行为",
        "6": "启用链路",
        "7": "禁用链路",
        "8": "修改名称"
    },
    PostBackAction: { //行为枚举
        '20': '添加联系人',
        '25': '开口',
        "30": "48小时删除联系人",
        "26": "开口-腾讯二次回传"
    },
    //请求code枚举
    ResponseCode: {
        SUCCESS: 0,
        SKU_NOT_ON_SALE: 81040006, //"商品未上架"
        SKU_USER_MAX_LIMIT: 81040016, //"超出商品限购数量"
        SKU_USER_SERVICE_PERIOD_LIMIT: 81040017 //"超出商品限购服务期"
    },
    //优惠券枚举
    CouponUnailableReasonConstant: {
        REASON_USED: 1,
        REASON_NOT_START: 2,
        REASON_EXPIRED: 3,
        REASON_NOT_SUPPORT: 4
    },
    //支付方式
    PayType: {
        WX: 10,
        ALI: 20,
        BANK: 30
    },
    PayTypeString: {
        10: "微信",
        20: "支付宝",
        30: "银行"
    },
    //支付登录端
    TradeType: {
        WEB: "WEB",
        JSAPI: "JSAPI"
    },
    OrderStatus: {
        PAID: 1, //已支付
        PAYING: 2, //待支付
        CLOSED: 3, //已关闭
        PASSED: 4, //已开通
        REFUND: 5 //已退款
    },
    OrderUnFinishedReason: {
        EXIST_UNPAID_ORDER: 1, //存在待支付的订单
        EXIST_UNSIGN_ORDER: 2, //存在待签字的订单
    },
    ElementType: {
        TWO_ELEMENTS: 2,
        THREE_ELEMENTS: 3
    },
    IdVerifyStatusConstant: {
        ID_VERIFYING: 0, // 待认证
        PASS: 1,         //认证通过
        REFUSE: 2        //认证失败
    },
    MessageManagementType: {
        Text: 0,  //文字消息
        Image: 10,  //图片消息
        Audio: 20,  //语音消息
        ImageText: 30, //图文消息
    },
    LabelStatusMap: {
        10: '正常上市',
        20: '退市',
        30: '待上市',
        90: '--' //其他
    },
    //  二档栏目枚举
    SecondGearColumn: {
        'QZXJTK02': 'prod111',//栏目-热点风口
        'ZZTP': 'prod112',//栏目-只做突破
        'SDJX': 'prod113',//栏目-赛道精选
        'QZXJTK': 'prod114'//栏目-题材潜伏
    },
    //  一档栏目枚举
    FirstGearColumn: {
        'yb010': 'prod115',
        'yb009': 'prod116',
        'yb008': 'prod117'
    },
    // 发票状态
    invoiceStatusEnum: {
        "1": "待开票",
        "2": "已开票",
        "3": "发票开具中-",
        "4": "发票开具中*",
        "5": "发票开具中"
    },
    indexPropertyEnum:{
        "exchange_id": "exchange_id",
        "market": "market",
        "code": "code",
        "指数名称": "name",
        "最新": "now",
        "开": "open",
        "高": "high",
        "成交量": "volume",
        "低": "low",
        "成交额": "amount",
        "昨收": "lastclose",
        "振幅": "amplitude",
        "流通股本": "cir_share_index",
        "流通市值": "cir_value",
        "总市值": "total_value",
        "市净率": "pb",
        "市盈率(动)": "pe_D",
        "市盈率(静)": "pe_S",
        "换手率":"traderate_index",
        "市盈率(TTM)": "pe_TTM",
        "上涨家数": "ad_stock",
        "下跌家数": "de_stock",
        "平盘家数": "un_stock"
    },
    bucketType: {
        evaluation: 1010,
        evaluationTemplate: 2010,
        wwxChat: 3010,
    },
    welfareGoodsStatus:{
        10:'未发货',//待初审
        20:'未发货',//初审通过/待复审
        30:'未发货',//初审拒绝
        40:'未发货',//复审通过
        50:'未发货',//复审拒绝
        60:'已发货' //已发货
    }

}
